import React, { Fragment } from 'react'

const PhraseExtract = () => {
  return (
    <Fragment>
      Selecione um período
    </Fragment>
  )
}

export default PhraseExtract



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/PhraseExtract.js